import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import axios, { AxiosError } from 'axios';
import {
  IDeleteAttendancePayload,
  IDeleteAttendanceResponse,
  IGetAllStaffAttendanceQuery,
  IMarkAbsentOrLeaveResponse,
  IMarkAttendanceResponse,
  IMarkingAbsentOrLeavePayload,
  IMarkingAbsentPayload,
  IMarkingCheckOutPayload,
  IMarkingTeacherAttendancePayload,
  ITeacherAttendanceApiResponse,
} from '../../interface/teacherAttendanceModel';
import {
  checkInTeacherAttendance,
  checkOutTeacherAttendance,
  getAllTeacherAttendance,
  hardDeleteTeacherAttendance,
  markAbsentTeacherAttendance,
  markLeaveTeacherAttendance,
} from '../../services/teacherAttendance';
import { IErrorResponse } from '../../interface/main.interface';

export const fetchAllStaffAttendance = createAsyncThunk<
  ITeacherAttendanceApiResponse,
  IGetAllStaffAttendanceQuery | undefined,
  { rejectValue: IErrorResponse }
>('teacherAttendance/get-all', async (params, { rejectWithValue }) => {
  try {
    const response = await getAllTeacherAttendance(params);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    } else {
      return rejectWithValue({ status: err.status || 500, message: err.message });
    }
  }
});

export const checkInTeachersAttendance = createAsyncThunk<
  IMarkAttendanceResponse,
  IMarkingTeacherAttendancePayload,
  { rejectValue: IErrorResponse }
>('teacherAttendance/check-in', async (payload, { rejectWithValue }) => {
  try {
    const response = await checkInTeacherAttendance(payload);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    } else {
      return rejectWithValue({ status: err.status || 500, message: err.message });
    }
  }
});

export const checkOutTeachersAttendance = createAsyncThunk<
  IMarkAttendanceResponse,
  IMarkingCheckOutPayload,
  { rejectValue: IErrorResponse }
>('teacherAttendance/check-out', async (payload, { rejectWithValue }) => {
  try {
    const response = await checkOutTeacherAttendance(payload);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    } else {
      return rejectWithValue({ status: err.status || 500, message: err.message });
    }
  }
});

// absent api
export const markAbsentTeachersAttendance = createAsyncThunk<
  IMarkAbsentOrLeaveResponse,
  IMarkingAbsentPayload,
  { rejectValue: IErrorResponse }
>('teacherAttendance/absent', async (payload, { rejectWithValue }) => {
  try {
    const response = await markAbsentTeacherAttendance(payload);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    } else {
      return rejectWithValue({ status: err.status || 500, message: err.message });
    }
  }
});

// leave api
export const markLeaveTeachersAttendance = createAsyncThunk<
  IMarkAbsentOrLeaveResponse,
  IMarkingAbsentOrLeavePayload,
  { rejectValue: IErrorResponse }
>('teacherAttendance/leave', async (payload, { rejectWithValue }) => {
  try {
    const response = await markLeaveTeacherAttendance(payload);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    } else {
      return rejectWithValue({ status: err.status || 500, message: err.message });
    }
  }
});

// Delete attendance record

export const deleteAttendance = createAsyncThunk<
  IDeleteAttendanceResponse,
  IDeleteAttendancePayload,
  { rejectValue: IErrorResponse }
>('teacherAttendance/delete', async (payload, { rejectWithValue }) => {
  try {
    const response = await hardDeleteTeacherAttendance(payload);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    } else {
      return rejectWithValue({ status: err.status || 500, message: err.message });
    }
  }
});
